import { gql } from '@apollo/client';

export const GET_CREATOR_TASKS_CONFIG = gql`
  query GetCreatorTasksConfig($programId: Int!) {
    creatorTasksConfigs(programId: $programId) {
      id
      isInitial
      order
      programId
      specURI
      stageId
    }
  }
`;

export const UPDATE_CREATOR_TASKS_CONFIG = gql`
  mutation UpdateCreatorTasksConfig($programId: Int!, $tasks: [CreatorTasksConfigInput!]!) {
    updateCreatorTasksConfig(programId: $programId, tasks: $tasks) {
      id
      isInitial
      order
      programId
      specURI
      stageId
    }
  }
`;
